var script_loaded = !1
if (void 0 === __isPSA) var __isPSA = !1
if (typeof window.uLTS === 'undefined') {
  window.uLTS = new MutationObserver((e) => {})
  window.uLTS.observe(document.documentElement, { childList: !0, subtree: !0 })
}
function loadJSscripts() {
  script_loaded ||
    (window.uLTS && window.uLTS.disconnect(),
    void 0 !== window.yett && window.yett.unblock(),
    (script_loaded = !0),
    document
      .querySelectorAll('iframe[data-src], script[data-src]')
      .forEach((e) => {
        null != (datasrc = e.dataset.src) && (e.src = datasrc)
      }),
    document.querySelectorAll("script[type='text/lazyload']").forEach((e) => {
      try {
        var t = document.createElement('script')
        for (a = 0; a < e.attributes.length; a++) {
          var r = e.attributes[a]
          t.setAttribute(r.name, r.value)
        }
        ;(t.type = 'text/javascript'),
          (t.innerHTML = e.innerHTML),
          e.parentNode.insertBefore(t, e),
          e.parentNode.removeChild(e)
      } catch (err) {
        console.error('footer.js Error loading script:', err)
      }
    }),
    document.dispatchEvent(new CustomEvent('asyncLazyLoad')),
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('loadBarInjector'))
    }, 1e3))
}
loadJSscripts()
